import axiosInstance from './axiosInstance';

export const getAdminSummary    = ()             => axiosInstance.get('analytics/admin/platform-summary/');
export const getAdminCategories = ()             => axiosInstance.get('analytics/admin/category-breakdown/');
export const getAdminCreators   = (limit = 10)   => axiosInstance.get('analytics/admin/top-creators/',      { params: { limit } });
export const getAdminTopPosts   = (days = 7)     => axiosInstance.get('analytics/admin/top-posts/',         { params: { days, limit: 10 } });
export const getAdminTimeseries = (days = 30)    => axiosInstance.get('analytics/admin/growth-timeseries/', { params: { days } });
